// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__FWKJN"};